import React from "react";
import { Box } from "@mui/material";

/**
 * A circular button component used to remove images
 * @param {Object} props - Component properties
 * @param {Function} props.onClick - Function to call when button is clicked
 * @param {number} [props.top=10] - Position from top
 * @param {number} [props.right=10] - Position from right
 * @param {number} [props.size=36] - Size of the button
 * @param {string} [props.fontSize="20px"] - Font size of the X symbol
 */
const RemoveImageButton = ({
  onClick,
  top = 10,
  right = 10,
  size = 36,
  fontSize = "20px",
}) => {
  return (
    <Box
      sx={{
        position: "absolute",
        top: top,
        right: right,
        backgroundColor: "rgba(0,0,0,0.5)",
        borderRadius: "50%",
        width: size,
        height: size,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        transition: "all 0.2s ease",
        "&:hover": {
          backgroundColor: "rgba(0,0,0,0.7)",
        },
      }}
      onClick={onClick}
    >
      <span style={{ fontSize: fontSize, color: "white" }}>✕</span>
    </Box>
  );
};

export default RemoveImageButton;
